<template>
    <div id="showroom">
        <div>
            <header><img loading="lazy" src="../assets/fleet-solutions.webp" alt="banner img"></header>

            <div class="container">
                <h1>show room</h1>

                <div class="block">
                    


                    <section class="container">
                        <div>
                            <!-- selector -->
                            <div class="form">
                                <div>
                                    <label class="title">select showroom</label>
                                    <div class="selected" @click="showroomsMenu = !showroomsMenu">
                                        {{currentArea }}
                                        <svg :style="{transform: showroomsMenu? 'rotate(180deg)':'rotate(0deg)'}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6">
                                            <path fill-rule="evenodd" d="M12.53 16.28a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 14.69l6.97-6.97a.75.75 0 1 1 1.06 1.06l-7.5 7.5Z" clip-rule="evenodd" />
                                        </svg>
                                    </div>
                                    
                                    <transition name="slide" mode="out-in" appear>
                                        <div class="menu" v-if="showroomsMenu">
                                            <span v-for="(x, index) in showrooms"
                                                        :key="index" 
                                                        @click="currentArea=x?.locationName; bindCurrentShowroom(x?.locationName); showroomsMenu=false">
                                                {{ x?.locationName }}
                                            </span>
                                        </div>
                                    </transition>
                                </div>
                            </div>

                            <!-- dynamice content displaying -->
                            <h4>{{ currentShowroom.locationName }}</h4>
                            <a :href="`tel:${currentShowroom.phone}`">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6">
                                    <path fill-rule="evenodd" d="M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z" clip-rule="evenodd" />
                                </svg>
                                {{ currentShowroom.phone }}
                            </a>
                            <a :href="`mailto:${currentShowroom.email}`">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6">
                                    <path d="M1.5 8.67v8.58a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.67l-8.928 5.493a3 3 0 0 1-3.144 0L1.5 8.67Z" />
                                    <path d="M22.5 6.908V6.75a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v.158l9.714 5.978a1.5 1.5 0 0 0 1.572 0L22.5 6.908Z" />
                                </svg>
                                {{ currentShowroom.email }}
                            </a>
                            <br>
                            <a :href="currentShowroom.mapsLocation" class="square">
                                Get direction
                                <svg xmlns="http://www.w3.org/2000/svg" class="size-6" viewBox="0 0 640 640"><!--!Font Awesome Free 7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc. --><path d="M352 348.4C416.1 333.9 464 276.5 464 208C464 128.5 399.5 64 320 64C240.5 64 176 128.5 176 208C176 276.5 223.9 333.9 288 348.4L288 544C288 561.7 302.3 576 320 576C337.7 576 352 561.7 352 544L352 348.4zM328 160C297.1 160 272 185.1 272 216C272 229.3 261.3 240 248 240C234.7 240 224 229.3 224 216C224 158.6 270.6 112 328 112C341.3 112 352 122.7 352 136C352 149.3 341.3 160 328 160z"/></svg>
                            </a>
                        </div>

                        <div style=" width: 100%; aspect-ratio: 16 / 9;">
                            <!-- <img loading="lazy" :src="currentShowroom.map" :alt="currentShowroom.locationName"> -->
                            <iframe :src="currentShowroom.map" allowfullscreen="" style="width: 100%; height: 100%; border: 0; border-radius: 10px;" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                currentArea: "tripoli",
                showroomsMenu: false,
                currentShowroom: null,
                showrooms: [
                    {
                        locationName: 'tripoli',
                        phone: '+218-915753737',
                        email: 'sales@alimtiyazgroup.com',
                        map: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4118.946192986416!2d13.2474606!3d32.8715323!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13a893de0020085b%3A0x4204c05eecb0815c!2z2YXYudix2LYg2LPZitin2LHYp9iqINi02YrYsdmKINmE2YrYqNmK2KcgQ2hlcnk!5e1!3m2!1sar!2sly!4v1768117333069!5m2!1sar!2sly',
                        mapsLocation: 'https://www.google.com/maps/dir/?api=1&origin=V5PR%2BVGP%2C%20Tripoli%2C%20Libya&destination=V6CX%2BH2M%2C%20Tripoli%2C%20Libya&travelmode=driving'
                    },
                    {
                        locationName: 'Zliten',
                        phone: '+218-915753232',
                        email: 'sales@alimtiyazgroup.com',
                        map: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4137.748189568416!2d14.563660500000003!3d32.4645701!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13a691ec49112791%3A0x19ed708d8109ad20!2z2YXYrNmF2YjYudipINin2YTYp9mF2KrZitin2LIg2YjZg9mK2YQg2LPZitin2LHYp9iqINi02YrYsdmK!5e1!3m2!1sar!2sly!4v1768117516365!5m2!1sar!2sly',
                        mapsLocation: 'https://www.google.com/maps/dir/?api=1&origin=V5PR%2BVGP%2C%20Tripoli%2C%20Libya&destination=FH77%2BRCQ%2C%20Zliten%2C%20Zliten%2C%20Libya&travelmode=driving'
                    },
                    {
                        locationName: 'Misurata',
                        phone: '+218-915753636',
                        email: 'sales@alimtiyazgroup.com',
                        map: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4142.870043964713!2d15.077764799999997!3d32.352920499999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13a14d000a83ba8f%3A0xa464e4a56d37f1dc!2z2LTZitix2Yog2YXYrNmF2YjYudipINin2YTYpdmF2KrZitin2LI!5e1!3m2!1sar!2sly!4v1768117441479!5m2!1sar!2sly',
                        mapsLocation: 'https://www.google.com/maps/dir/?api=1&origin=V5PR%2BVGP%2C%20Tripoli%2C%20Libya&destination=9346%2BXC3%2C%20Misurata%2C%20Misurata%2C%20Libya&travelmode=driving'
                    },
                    {
                        locationName: 'Benghazi',
                        phone: '+218-915753838',
                        email: 'sales@alimtiyazgroup.com',
                        map: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4157.348840831727!2d20.1188786!3d32.0354265!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13831ba5e6baafa3%3A0x33b115568a19a36c!2z2YXYudix2LYg2LTZitix2Yog2KjZhti62KfYstmKIENoZXJ5!5e1!3m2!1sar!2sly!4v1768117566184!5m2!1sar!2sly',
                        mapsLocation: 'https://www.google.com/maps/dir/?api=1&origin=V5PR%2BVGP%2C%20Tripoli%2C%20Libya&destination=24P9%2B6H2%2C%20Benghazi%2C%20Benghazi%2C%20Libya&travelmode=driving'
                    },
                    {
                        locationName: 'AlBayda',
                        phone: '+218-915753939',
                        email: 'sales@alimtiyazgroup.com',
                        map: 'https://www.google.com/maps/embed?pb=!1m10!1m8!1m3!1d257.6751317973748!2d21.797147690763573!3d32.788438538107236!3m2!1i1024!2i768!4f13.1!5e1!3m2!1sen!2sly!4v1768116696325!5m2!1sen!2sly',
                        mapsLocation: 'https://www.google.com/maps/dir/?api=1&origin=V5PR%2BVGP%2C%20Tripoli%2C%20Libya&destination=AlBayda%2C%20AlBayda%2C%20Libya&travelmode=driving'
                    },

                ]
            }
        },
        methods: {
            bindCurrentShowroom(lname) {
                let x = this.showrooms.find(i => i.locationName?.toLowerCase() == lname.toLowerCase())
                this.currentShowroom = x;
            }
        },
        mounted() {
            this.bindCurrentShowroom('tripoli');
        }
    }
</script>